export const stringToBoolean = (string) => {
    // !! \\ undefined == false
    switch (string) {
        case true: case "True": case "true": case "yes": case "1": return true;
        case false: case "False": case "false": case "no": case "0": case null: return false;
        default: return Boolean(string);
    }
}